import { put, select, takeLatest } from 'redux-saga/effects'
import { getPatientImmunizationsSelector } from '../selectors'
import { IPatientImmunizationsState } from '../store/patientImmunizations.types'
import { PatientImmunizationsConstants } from '../store/patientImmunizations.constants'
import { setImmunizations } from '../store/patientImmunizations.actions'
import { throwPcrException } from '../../pcr/store/pcr.actions'

export function* setImmunizationYear() {
  const immunization: IPatientImmunizationsState = yield select(getPatientImmunizationsSelector)
  const { immunizations, year, key } = immunization
  const updatedImmunization = [...immunizations]
  const selectedImmunization = updatedImmunization.find((immune) => immune.key === key)

  try {
    if (selectedImmunization) {
      selectedImmunization.year = year
      yield put(setImmunizations(updatedImmunization))
    }
  } catch (e) {
    yield put(throwPcrException(`setImmunizationYear() error: ${e}`))
  }
}

export function* setImmunizationYearSaga() {
  yield takeLatest([PatientImmunizationsConstants.SET_YEAR], setImmunizationYear)
}
